import {StorageService} from '../../Services/StorageService';
import {NotificationService} from '../../Services/NotificationService';
import {NavigationService} from '../../Services/NavigationService';
import {AuthenticationService} from '../../Services/AuthenticationService';
import {IUserVm} from '../../Data/Data';
import {UserService} from '../../Services/UserService';
import * as angular from 'angular';

export class SettingsController {
  static controllerId = 'SettingsController';
  static $inject = [
    '$scope',
    '$state',
    '$stateParams',
    StorageService.serviceId,
    NotificationService.serviceId,
    AuthenticationService.serviceId,
    NavigationService.serviceId,
    UserService.serviceId,
  ];

  editPassword: boolean = false;
  user: IUserVm;
  passwordMaxLength = 20;
  forced = false;

  constructor(private $scope: ng.IScope,
              private $state,
              private $stateParams,
              private storage: StorageService,
              private notification: NotificationService,
              private authentication: AuthenticationService,
              private navigation: NavigationService,
              private userService: UserService) {
    this.user = <IUserVm>{
      oldPassword: '',
      password: '',
      passwordConfirm: '',
    };
    console.log(this.$stateParams);
    this.forced = this.$stateParams.forced;
  }

  changePw() {
    this.editPassword = true;
  }

  stopChangePw() {
    this.editPassword = false;
  }

  private validate() {

    if (!angular.isString(this.user.oldPassword) || this.user.oldPassword.length < 1) {
      this.notification.error(`Das Feld 'Altes Passwort' darf nicht leer sein`);
      return false;
    }

    if (!angular.isString(this.user.password || this.user.password.length < 1)) {
      this.notification.error(`Das Feld 'Neues Passwort' darf nicht leer sein`);
      return false;
    }
    if (!angular.isString(this.user.passwordConfirm || this.user.passwordConfirm.length < 1)) {
      this.notification.error(`Das Feld 'Passwort wiederholen' darf nicht leer sein`);
      return false;
    }

    const validationResult = this.validatePassword(this.user.password);
    if (!validationResult.valid) {
      this.notification.error(validationResult.info);
      return false;
    }

    if (this.user.password !== this.user.passwordConfirm) {
      this.notification.error(`Die Passwörter stimmen nicht überrein`);
      return false;
    }

    return true;
  }

  async savePw() {
    if (!this.validate()) {
      return;
    }
    try {
      await this.userService.editPassword(this.user);
      this.user.password = '';
      this.user.passwordConfirm = '';
      this.user.oldPassword = '';
      this.editPassword = false;
      this.notification.info('Passwort geändert. Bitte loggen Sie sich erneut ein.');
      await this.authentication.logout();
      setTimeout(() => window.location.reload(), 1000);
    } catch (e) {
      console.log(e);
      this.notification.error('Passwort editieren fehlgeschlagen');
    }
  }

  goBack() {
    this.navigation.goToMenu();
  }

  private validatePassword(pw: string): { valid: boolean, info: string } {
    let containsLowerCase = false;
    let containsUpperCase = false;
    let containsDigit = false;
    let containsSpecial = false;

    if (pw.length < 8) {
      return {valid: false, info: 'Das neue Passwort muss mindest 8 Zeichen lang sein.'};
    }
    const lca = 'a'.charCodeAt(0);
    const lcz = 'z'.charCodeAt(0);
    const uca = 'A'.charCodeAt(0);
    const ucz = 'Z'.charCodeAt(0);
    const zero = '0'.charCodeAt(0);
    const nine = '9'.charCodeAt(0);

    for (let i = 0; i < pw.length; i++) {
      const char = pw.charCodeAt(i);
      if (char >= lca && char <= lcz) {
        containsLowerCase = true;
      } else if (char >= uca && char <= ucz) {
        containsUpperCase = true;
      } else if (char >= zero && char <= nine) {
        containsDigit = true;
      } else {
        containsSpecial = true;
      }
    }

    let rulesFulfilled = 0;
    if (containsLowerCase) {
      rulesFulfilled++;
    }
    if (containsUpperCase) {
      rulesFulfilled++;
    }
    if (containsDigit) {
      rulesFulfilled++;
    }
    if (containsSpecial) {
      rulesFulfilled++;
    }

    if(rulesFulfilled >= 3) {
      return {valid: true, info: ''};
    }

    return {
      valid: false,
      info: 'Das neue Passwort muss mindestens 3 von den folgenden 4 Zeichen enthalten: Kleinbuchstaben, Grossbuchstaben, Zahl, Sonderzeichen.'
    };
  }
}
